import { compose } from 'recompose';
import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import CSSModules from 'react-css-modules';

import styles from './styles.styl';

import * as complaintDetails from '../../../../redux/complaints/complaintDetails';
import * as resolveComplaint from '../../../../redux/complaints/resolveComplaint';
import {
  selectComplaintDetails,
  selectComplaintDetailsLoading,
  selectResolveComplaintLoading,
} from '../../../../redux/complaints/selectors';

const mapStateToProps = state => ({
  loading: selectComplaintDetailsLoading(state),
  details: selectComplaintDetails(state),
  resolveLoading: selectResolveComplaintLoading(state),
});

const mapDispatchToProps = {
  fetchComplaint: complaintDetails.actions.send,
  resetDetails: complaintDetails.actions.reset,
  resolve: resolveComplaint.actions.send,
};

export const enhance = compose(
  injectIntl,
  connect(
    mapStateToProps,
    mapDispatchToProps,
  ),
  CSSModules(styles, { allowMultiple: true }),
);



// WEBPACK FOOTER //
// ./src/components/Communities/Reports/ReportsList/enhance.js